import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user/user.service";
@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {
  pwd           = '';
  cPwd          = '';
  success       = false;
  errorMatching = false;
  errorRequis   = false;
  profile = {email:"",tel:"",adresse:"",ville:"",ice:"",raisonSociale:""};
  constructor(private userService:UserService) {


  }

  ngOnInit(): void {
    

    this.userService.getProfile().subscribe(res=>{
      this.profile.email = res["profile"].WEB;
      this.profile.tel = res["profile"].TEL;
      this.profile.adresse = res["profile"].BPAADDLIG0;
      this.profile.ville = res["profile"].CTY;
      this.profile.ice = res["profile"].XICE;
      this.profile.raisonSociale = res["profile"].BPRNUM;
      console.log(this.profile);

    })
  }

  changePwd(){
    if(this.pwd !="" && this.cPwd !=""){
      if( this.pwd == this.cPwd){
        var user = JSON.parse(localStorage.getItem('user'))
        var data = {"username": user.user,"pwd": this.pwd}
        this.userService.changePassword(data).subscribe(res=>{
          if(res){
            this.success       = true
            this.errorRequis   = false;
            this.errorMatching = false;
          }
        })

      }else{
        this.errorRequis   = false;
        this.errorMatching = true;
      }
    }else{
      this.success       = false;
      this.errorRequis   = true;
      this.errorMatching = false;
    }
 }



}
